<div class="container">
    <div class="row">
        
                <h3 class="ff-medium text-uppercase fw-semibold fs-6 py-3">Ofertas</h3>
                <div class="row">
                    <ul class="list-unstyled">
                        <li class="mb-2">
                            <a href="https://ofertas.yamaha.bo/" class="text-uppercase ff-medium" (click)="cerrarMenu()">Motos</a>
                        </li>
                    </ul>
                </div>
                <h3 class="ff-medium text-uppercase fw-semibold fs-6 py-3" >Noticias</h3>
                <div class="row">
                    <ul class="list-unstyled">
                        <li class="mb-2">
                            <a href="https://noticias.toyosa.com/yamaha" class="text-uppercase ff-medium" (click)="cerrarMenu()">Yamaha</a>
                        </li>
                    </ul>
                </div>
            
    </div>
</div>
